import { useEffect, useState } from "react";

import {
  useLocalVideo,
  useMeetingStatus,
} from "amazon-chime-sdk-component-library-react";

import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";

import ControlButton from "./control-button";

import SelectCameraPopover from "../../../video/controls/select-camera-popover";
import { Divider } from "@mui/material";

interface CameraProps {
  startWithVideo: boolean;
  showText?: boolean;
  disabled?: boolean;
  onCameraFound?: (found: string | undefined) => void;
  cameraType?: string;
  subCameraType?: string;
}

const DropDownCameraButton: React.FC<CameraProps> = ({
  startWithVideo,
  onCameraFound,
  showText,
  cameraType,
  subCameraType,
  disabled = false,
}) => {
  const { isVideoEnabled, toggleVideo } = useLocalVideo();
  const status = useMeetingStatus();

  const [isWaiting, setIsWaiting] = useState<boolean>(false)
  const [triedStart, setTriedStart] = useState<boolean>(false);

  const onCameraButton = (active: boolean) => {
    if (isVideoEnabled === active) {
      return;
    }

    if (status != 1) {
      return;
    }

    if (isWaiting) {
      return;
    }

    setIsWaiting(true);
  };

  // when button is clicked starts wait for toggle video
  useEffect(() => {
    if (status != 1) {
      return;
    }

    if (!isWaiting) {
      return;
    }

    waitThenToggleVideo();
  }, [isWaiting]);

  const waitThenToggleVideo = async () => {
    if (!isWaiting) {
      return;
    }

    // Ensure that a toggle calls is not made if before the button is finished waiting
    await toggleVideo();

    setIsWaiting(false);
  };

  // handles starting with video
  useEffect(() => {
    if (status != 1) {
      return;
    }

    if (triedStart) {
      return;
    }

    onCameraButton(startWithVideo);
    setTriedStart(true);
  }, [startWithVideo, status]);

  return (
    <ControlButton
      disabled={disabled}
      activeIcon={<VideocamIcon color="action" />}
      inactiveIcon={<VideocamOffIcon color="action" />}
      active={isVideoEnabled}
      onClick={onCameraButton}
      activeLabel={"Disable Camera"}
      inactiveLabel={"Enable Camera"}
      showText={showText}
    >
      <Divider orientation="vertical" />
      <SelectCameraPopover
        onCameraFound={onCameraFound}
        cameraType={cameraType}
        subCameraType={subCameraType}
      />
    </ControlButton>
  );
};

export default DropDownCameraButton;
